export const INVOICE_STATUSES = [
  { value: "DRAFT", label: "Draft", color: "default" },
  { value: "SAVED", label: "Saved (Live)", color: "blue" },
  { value: "SENT", label: "Sent", color: "geekblue" },
  { value: "PARTIALLY_PAID", label: "Partially Paid", color: "orange" },
  { value: "PAID", label: "Paid", color: "green" },
  { value: "OVERDUE", label: "Overdue", color: "red" },
  { value: "CANCELLED", label: "Cancelled", color: "default" },
];

export const PAYMENT_METHODS = [
  { value: "CASH", label: "Cash" },
  { value: "CHECK", label: "Check" },
  { value: "BANK_TRANSFER", label: "Bank Transfer" },
  { value: "CREDIT_CARD", label: "Credit Card" },
  { value: "STRIPE", label: "Stripe" },
  { value: "PAYPAL", label: "PayPal" },
  { value: "CRYPTO_BTC", label: "Bitcoin (BTC)" },
  { value: "CRYPTO_ETH", label: "Ethereum (ETH)" },
  { value: "OTHER", label: "Other" },
];

export const FREQUENCIES = [
  { value: "DAILY", label: "Daily" },
  { value: "WEEKLY", label: "Weekly" },
  { value: "MONTHLY", label: "Monthly" },
  { value: "QUARTERLY", label: "Quarterly" },
  { value: "YEARLY", label: "Yearly" },
  { value: "EVERY_X_MONTHS", label: "Every X Months" },
];

export const US_STATES = [
  "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "DC", "FL", "GA", "HI",
  "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN",
  "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "OH",
  "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA",
  "WV", "WI", "WY",
];

export const UNIT_OPTIONS = [
  "Monthly",
  "Weekly",
  "Yearly",
  "Per Device",
  "Hours",
  "Each",
];

export const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

export function statusMeta(value) {
  return (
    INVOICE_STATUSES.find((s) => s.value === value) || {
      value,
      label: value,
      color: "default",
    }
  );
}

export function money(amount, currency) {
  const n = Number(amount) || 0;
  return `${currency || "USD"} ${n.toFixed(2)}`;
}

export function round2(n) {
  return Math.round((Number(n) + Number.EPSILON) * 100) / 100;
}

/**
 * Compute line + invoice totals client-side for live preview (mirrors the
 * server calculation in api/utils/billing.js).
 */
export function computeLine(line) {
  const quantity = Number(line.quantity) || 0;
  const rate = Number(line.rate) || 0;
  const amount = round2(quantity * rate);
  const discountPct = Number(line.discount_percentage) || 0;
  const discountAmt = round2((amount * discountPct) / 100);
  const afterDiscount = round2(amount - discountAmt);
  const taxable = line.is_taxable !== false;
  const taxPct = taxable ? Number(line.tax_percentage) || 0 : 0;
  const taxAmt = taxable ? round2((afterDiscount * taxPct) / 100) : 0;
  return {
    ...line,
    amount,
    discount_amount_calculated: discountAmt,
    amount_after_discount: afterDiscount,
    tax_percentage: taxPct,
    tax_amount_calculated: taxAmt,
    amount_total: round2(afterDiscount + taxAmt),
  };
}

export function computeInvoiceTotals(items, discountType, discountValue, adjustment) {
  const lines = (items || []).map(computeLine);
  const subtotal = round2(
    lines.reduce((s, l) => s + (Number(l.amount_after_discount) || 0), 0)
  );
  const dv = Number(discountValue) || 0;
  const invoiceDiscount =
    discountType === "PERCENT" ? round2((subtotal * dv) / 100) : round2(dv);
  // Same as the API: the invoice discount comes off before tax, each line
  // taxed on its share of the discounted subtotal.
  const share = subtotal > 0 ? 1 - Math.min(invoiceDiscount / subtotal, 1) : 1;
  const taxTotal = round2(
    lines.reduce(
      (s, l) => s + round2((l.amount_after_discount * share * l.tax_percentage) / 100),
      0
    )
  );
  const adj = Number(adjustment) || 0;
  const grand = round2(subtotal - invoiceDiscount + taxTotal + adj);
  return {
    lines,
    subtotal,
    discount_amount: invoiceDiscount,
    tax_total: taxTotal,
    grand_total: grand < 0 ? 0 : grand,
  };
}
